<template>
    <v-container>
        <v-card outlined class="ma-5">
            <v-card-title>
                <span class="headline">Melding aanmaken</span>
            </v-card-title>
            <v-card-subtitle class="ml-0">Laat velden leeg voor willekeurige naam/monteur.</v-card-subtitle>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-select outlined class="mb-0" label="Type melding" :items="types" v-model="selected">Type</v-select>
                        <v-select outlined class="mb-0" label="Kanaal" :items="channels" v-model="filterId">Kanaal</v-select>
                    </v-row>
                    <v-row>
                        <v-text-field
                                v-model="description"
                                label="Beschrijving melding"
                                outlined
                                class="mb-0"
                        />
                    </v-row>
                    <v-row>
                        <v-text-field
                                v-model="acceptee"
                                label="Naam monteur"
                                outlined
                                class="mb-0"
                        />
                    </v-row>
                    <v-row>
                        <v-text-field
                                v-model="location"
                                label="Locatie"
                                outlined
                                class="mb-0"
                        />
                    </v-row>

                    <v-row>
                        <v-text-field
                                v-model="memo"
                                label="Advies"
                                outlined
                                class="mb-0"
                        />
                    </v-row>
                    <v-row justify="center">
                        <v-date-picker v-model="picker"></v-date-picker>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-text>{{finished}}</v-text>

                <v-btn color="blue darken-1" text @click="generateAlarm()">Aanmaken</v-btn>
            </v-card-actions>
        </v-card>

        <v-card outlined class="ma-5">
            <v-card-title>
                <span class="title">Invoersuggesties conclusie</span>
            </v-card-title>
            <v-row>
                <v-text-field
                        v-model="conclusionSuggestion"
                        label="Suggestietext"
                        outlined
                        class="ml-5 mr-5"
                />
            </v-row>
            <v-btn class="ml-10 mr-10 mb-10" @click="addConclusionSuggestion()">Toevoegen<v-icon>mdi-plus-thick</v-icon></v-btn>
            <v-card-subtitle>Suggesties:</v-card-subtitle>
            <container v-for="(sug, i) in conclusionSuggestions" :key="i">
                <v-text class="ma-4 mb-10" >{{sug}}</v-text>
                <v-btn outlined class="mb-1" @click="removeConclusionSuggestion(sug)"><v-icon>mdi-minus-circle</v-icon></v-btn>
                <pre></pre>
            </container>
        </v-card>

        <v-card outlined class="ma-5">
            <v-card-title>
                <span class="title">Invoersuggesties opvolging</span>
            </v-card-title>
            <v-row>
                <v-text-field
                        v-model="reparationSuggestion"
                        label="Suggestietext"
                        outlined
                        class="ml-5 mr-5"
                />
            </v-row>
            <v-btn class="ml-10 mr-10 mb-10" @click="addReparationSuggestion()">Toevoegen<v-icon>mdi-plus-thick</v-icon></v-btn>
            <v-card-subtitle>Suggesties:</v-card-subtitle>
            <container v-for="(sug, i) in reparationSuggestions" :key="i">
                <v-text class="ma-4 mb-10" >{{sug}}</v-text>
                <v-btn outlined class="mb-1" @click="removeReparationSuggestion(sug)"><v-icon>mdi-minus-circle</v-icon></v-btn>
                <pre></pre>
            </container>
        </v-card>

        <v-card outlined class="ma-5">
            <v-card-title>
                <span class="title">Invoersuggesties notities</span>
            </v-card-title>
            <v-row>
                <v-text-field
                        v-model="noteSuggestion"
                        label="Suggestietext"
                        outlined
                        class="ml-5 mr-5"
                />
            </v-row>
            <v-btn class="ml-10 mr-10 mb-10" @click="addNoteSuggestion()">Toevoegen<v-icon>mdi-plus-thick</v-icon></v-btn>
            <v-card-subtitle>Suggesties:</v-card-subtitle>
            <container v-for="(sug, i) in noteSuggestions" :key="i">
                <v-text class="ma-4 mb-10" >{{sug}}</v-text>
                <v-btn outlined class="mb-1" @click="removeNoteSuggestion(sug)"><v-icon>mdi-minus-circle</v-icon></v-btn>
                <pre></pre>
            </container>
        </v-card>

        <v-card outlined class="ma-5">
            <v-btn class="ma-10" color="grey" @click="removeAlarms()">Verwijder actieve alarmen</v-btn>
            <v-btn class="ma-10" color="grey" @click="removeHistory()">Verwijder historie</v-btn>
            <v-btn class="ma-10" color="yellow" @click="generateAlarmRandom()">Willekeurige melding</v-btn>
        </v-card>


        <div>
            <v-row justify="center">
                <v-dialog v-model="dialog" persistent max-width="600px">

                </v-dialog>
            </v-row>
        </div>
    </v-container>



</template>

<script>
    import axios from "axios";
    import config from '../config/config.js'

    export default {
        name: "BackOffice",
        data() {
            return {
                selected:undefined,
                picker: new Date().toISOString().substr(0, 10),
                finished: undefined,
                memo: undefined,
                dialog: false,
                location: undefined,
                acceptee: undefined,
                description:undefined,
                types: ["Alarm", "Notificatie", "Informatie"],
                channels: [1,2,3,4,5,6,7,8],
                filterId: undefined,
                conclusionSuggestion: "",
                conclusionSuggestions: [],
                reparationSuggestion: "",
                reparationSuggestions: [],
                noteSuggestion: "",
                noteSuggestions: []
            }
        },
        methods: {
            generateAlarm() {
                if(this.selected && this.acceptee && this.filterId && this.location) {
                    this.finished = "Alarm aangemaakt."
                    axios
                        .post(config.url +'/alarms/generate', {type: this.selected, acceptee: this.acceptee, description: this.description, filterId: this.filterId, location: this.location, memo: this.memo, date: this.picker})
                } else {
                    this.finished = "Vul aub alle velden in."
                }

            },
            removeReparationSuggestion(sug) {
                const index = this.reparationSuggestions.indexOf(sug);
                this.reparationSuggestions.splice(index, 1);
                // eslint-disable-next-line no-console
                console.log(sug)

                axios.post(config.url + '/suggestions/reparation', {suggestions: this.reparationSuggestions})

            },
            removeNoteSuggestion(sug) {
                const index = this.noteSuggestions.indexOf(sug);
                this.noteSuggestions.splice(index, 1);
                // eslint-disable-next-line no-console
                console.log(sug)

                axios.post(config.url + '/suggestions/notes', {suggestions: this.noteSuggestions})

            },
            removeConclusionSuggestion(sug) {
                const index = this.conclusionSuggestions.indexOf(sug);
                this.conclusionSuggestions.splice(index, 1);
                // eslint-disable-next-line no-console
                console.log(sug)

                axios.post(config.url + '/suggestions/conclusion', {suggestions: this.conclusionSuggestions})

            },
            generateAlarmRandom() {
                axios
                    .post(config.url +'/alarms/generate')
            },
            removeAlarms() {
                axios
                    .post(config.url + '/alarms/removealarms')
            },
            removeHistory() {
                axios
                    .post(config.url + '/alarms/removehistory')
            },
            addConclusionSuggestion() {
                if(this.conclusionSuggestion !== "") {
                    this.conclusionSuggestions.push(this.conclusionSuggestion)
                    axios.post(config.url + '/suggestions/conclusion', {suggestions: this.conclusionSuggestions})
                }
                this.conclusionSuggestion = ""
            },
            addReparationSuggestion() {
                if(this.reparationSuggestion !== "") {
                    this.reparationSuggestions.push(this.reparationSuggestion)
                    axios.post(config.url + '/suggestions/reparation', {suggestions: this.reparationSuggestions})
                }
                this.reparationSuggestion = ""
            },
            addNoteSuggestion() {
                if(this.noteSuggestion !== "") {
                    this.noteSuggestions.push(this.noteSuggestion)
                    axios.post(config.url + '/suggestions/notes', {suggestions: this.noteSuggestions})
                }
                this.noteSuggestion = ""
            }
        },
        mounted() {
            if(!localStorage["kanaal"+this.filterId]) {
                localStorage["kanaal" + this.filterId] = JSON.stringify({
                    memo: undefined,
                    selected: undefined,
                    picker: undefined,
                    location: undefined,
                    acceptee: undefined,
                    description: undefined
                })
            }
            let object = JSON.parse(localStorage["kanaal" + this.filterId])
            if(object.memo) {
                this.memo = localStorage[this.filterId].memo
            }
            if(object.selected) {
                this.selected = object.selected
            }
            if(object.picker) {
                this.picker = object.picker
            }
            if(object.location) {
                this.location = object.location
            }
            if(object.acceptee) {
                this.acceptee = object.acceptee
            }
            if(object.description) {
                this.description = object.description
            }
            axios.get(config.url + '/suggestions/conclusion').then((res) => {
                // eslint-disable-next-line no-console
                console.log(res)
                this.conclusionSuggestions = res.data[0].suggestions
            })

            axios.get(config.url + '/suggestions/reparation').then((res) => {
                // eslint-disable-next-line no-console
                console.log(res)
                this.reparationSuggestions = res.data[0].suggestions
            })

            axios.get(config.url + '/suggestions/notes').then((res) => {
                // eslint-disable-next-line no-console
                console.log(res)
                this.noteSuggestions = res.data[0].suggestions
            })

        },
        watch: {
            memo(newMemo) {
                let object = JSON.parse(localStorage["kanaal" + this.filterId])
                object.memo = newMemo
                localStorage["kanaal" + this.filterId] = JSON.stringify(object)
            },
            selected(newSelected) {
                let object = JSON.parse(localStorage["kanaal" + this.filterId])
                object.selected = newSelected
                localStorage["kanaal" + this.filterId] = JSON.stringify(object)            },
            picker(newPicker) {
                let object = JSON.parse(localStorage["kanaal" + this.filterId])
                object.picker = newPicker
                localStorage["kanaal" + this.filterId] = JSON.stringify(object)            },
            location(newLocation) {
                let object = JSON.parse(localStorage["kanaal" + this.filterId])
                object.location = newLocation
                localStorage["kanaal" + this.filterId] = JSON.stringify(object)
            },
            acceptee(newAcceptee) {
                let object = JSON.parse(localStorage["kanaal" + this.filterId])
                object.acceptee = newAcceptee
                localStorage["kanaal" + this.filterId] = JSON.stringify(object)
            },
            description(newDescription) {
                let object = JSON.parse(localStorage["kanaal" + this.filterId])
                object.description = newDescription
                localStorage["kanaal" + this.filterId] = JSON.stringify(object)
            },
            filterId(newFilterId) {
                if(!localStorage["kanaal" + newFilterId]) {
                    let object = {}
                    localStorage["kanaal" + this.filterId] = JSON.stringify(object)
                } else {
                    let object = JSON.parse(localStorage["kanaal" + newFilterId])
                    if(object.memo) {
                        this.memo = object.memo
                    }
                    if(object.selected) {
                        this.selected = object.selected
                    }
                    if(object.picker) {
                        this.picker = object.picker
                    }
                    if(object.location) {
                        this.location = object.location
                    }
                    if(object.acceptee) {
                        this.acceptee = object.acceptee
                    }
                    if(object.description) {
                        this.description = object.description
                    }
                }

            }
        }
    }
</script>

<style scoped>
</style>
